import { render } from "./StaffPositionIndex.vue?vue&type=template&id=f0fce488"
import script from "./StaffPositionIndex.vue?vue&type=script&lang=js"
export * from "./StaffPositionIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__